<template>
  <a-modal
    :open="open"
    @cancel="handleClose"
    class="sequence-history"
    centered
    :maskClosable="false"
    title="Historial de cambios"
    :bodyStyle="{ height: '500px', padding: '0px 8px' }"
    :width="400"
  >
    <CustomScrollbar height="500px" auto style="padding-top: 30px">
      <a-timeline>
        <a-timeline-item v-for="change in history" :key="change.id" :color="HistoryActionColor[change?.action]">
          <div>
            <span class="change-text">
              {{ dayjs(change.created_at).format("DD/MM/YYYY HH:mm") }} </span
            ><br />
            <span class="change-text" v-if="change.description">
              {{ change.description }}
            </span>
            <div class="change-user">
              <UserAvatar size="28px" class="avatar" :record="{ user: change.user }" />
              {{ change.user.fullname }}
            </div>
          </div>
        </a-timeline-item>
      </a-timeline>
    </CustomScrollbar>
    <template #footer>
      <a-divider style="margin-top: 0" />
      <a-button class="footer_btn" @click="handleClose">Cerrar Registro</a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import dayjs from "dayjs";

import { SequenceHistoryChange } from "@/@types/flows/sequences";
import { sequenceService } from "@/app/flows/sequences/services/Sequence.service";

import UserAvatar from "@/app/shared/components/avatar/UserAvatar.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { HistoryActionColor } from "@/app/flows/sequences/utils/enums.ts";

const props = defineProps<{ open: boolean; sequenceId: number }>();

const emit = defineEmits<{ "update:open": [open: boolean] }>();

const handleClose = () => emit("update:open", false);

const history = ref<SequenceHistoryChange[]>([]);

const fetchHistory = async () => {
  history.value = await sequenceService.getChangeHistory(props.sequenceId);
};

onMounted(() => fetchHistory());
</script>

<style scoped lang="sass">
.change-user
  display: flex
  align-items: center
  justify-content: flex-start
  gap: 6px
  margin-top: 4px
  color: $text-secondary
  text-transform: capitalize

.change-text
  color: $text-primary

:global(.sequence-history .ant-modal-footer)
  text-align: center
</style>
